// initial state
const state = () => ({
    referrals: []
})

// getters
const getters = {
    //
}

// actions
const actions = {
    getReferrals: async({ commit }) => {
        let { data } = await axios.get('referral')
        commit('setReferral', data);
    },
}

// mutations
const mutations = {
    setReferral(state, payload) {
        state.referrals = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
